import { ButtonMenu } from '@/components/componentLibrary/ButtonMenu'
import { ICON_MAP } from '@/components/componentLibrary/Icon/Icons'
import { IPS_APPS } from '@/components/curb/AppsMenu/constants'
import { useCurrentProduct } from '@/modules/urlRouting/hooks'
import { SEGMENTS } from '@/modules/urlRouting/paths'

// The IPS apps are only relevant to the curbs products, so this is an allowlist rather than
// a check against Mobility Manager: useCurrentProduct returns undefined on some routes.
const CURBS_PRODUCTS: string[] = [SEGMENTS.ELEVATE, SEGMENTS.REGULATIONS, SEGMENTS.MANAGEMENT]

const AppsMenu = () => {
  const currentProduct = useCurrentProduct()

  if (import.meta.env.VITE_POPULUS_DATACENTER !== 'us') return null
  if (!CURBS_PRODUCTS.includes(currentProduct ?? '')) return null

  return (
    <ButtonMenu
      label="IPS Apps"
      options={IPS_APPS}
      Icon={<ICON_MAP.apps />}
      square
      portalIntoHeader
    />
  )
}

export default AppsMenu
